import "component?js-Carousel"

let warnGlobalServicesUsage = true;
window.Fnac = window.Fnac || {};
// Use by Hooklogic code (see https://retail-eu.productads.hlserve.com/Delivery/ClientPaths/Library/hook.js?apiKey=95b9740b-d129-4677-9fa8-88c8a7d34a2b)
Object.defineProperty(Fnac.Services = Fnac.Services || {}, "instantiateService", {
  get: () => {
    if(warnGlobalServicesUsage){
      console.warn("Use global Fnac.Services.instantiateService is depreciated. It's no more needed");
    }
    warnGlobalServicesUsage = false;
    return {articleItem(){}, thumbnail(){}, carousel(){}};
  }
});
